import { useEffect, useRef, useState } from "react";

export default function InfiniteMarquee({
    children,
    groupClassName = "",
    duration = 28,
    copies = 4,
}) {
    const groupRef = useRef(null);
    const [shift, setShift] = useState(0);

    useEffect(() => {
        const el = groupRef.current;
        if (!el) return undefined;

        const measure = () => {
            const width = el.getBoundingClientRect().width;
            if (width > 0) setShift(width);
        };

        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        window.addEventListener("resize", measure);
        return () => {
            ro.disconnect();
            window.removeEventListener("resize", measure);
        };
    }, [children]);

    return (
        <div className="overflow-hidden">
            <div
                className="flex w-max will-change-transform"
                style={
                    shift
                        ? {
                              animation: `marquee-px ${duration}s linear infinite`,
                              "--marquee-shift": `-${shift}px`,
                          }
                        : undefined
                }
            >
                {Array.from({ length: copies }, (_, copy) => (
                    <div
                        key={copy}
                        ref={copy === 0 ? groupRef : undefined}
                        aria-hidden={copy > 0 || undefined}
                        className={`flex shrink-0 items-center ${groupClassName}`}
                    >
                        {children}
                    </div>
                ))}
            </div>
        </div>
    );
}
